import { render, staticRenderFns } from "./rich-text-editor.vue?vue&type=template&id=1d24464a&scoped=true&"
import script from "./rich-text-editor.vue?vue&type=script&lang=js&"
export * from "./rich-text-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-text-editor.vue?vue&type=style&index=0&id=1d24464a&lang=scss&scoped=true&"
import style1 from "./rich-text-editor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24464a",
  null
  
)

/* custom blocks */
import block0 from "./rich-text-editor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports